<div
  class="attachment-card-container"
  [object]="attachment"
  [attachmentType]="attachmentType"
  [image]="documentUrl(attachment)"
  [allDocuments]="allDocuments"
  [contextualInfo]="contextualInfo"
  ngImageGalleryPreview
>
  <div
    class="attachment-preview"
    (click)="onAttachmentClick()"
    [innerHTML]="getDocumentIcon(attachment) | safeHtml"
  ></div>
  <div class="attachment-info">
    <div class="attachment-info-container text-truncate">
      <div class="attachment-name text-truncate">
        <ng-container *ngIf="attachment.title">{{ attachment.title }}</ng-container>
        <ng-container *ngIf="!attachment.title">{{ attachment.filename }}</ng-container>
      </div>
      <div class="attachment-date">{{ attachmentCreatedDate }}</div>
    </div>
    <div class="attachment-actions-container" *ngIf="!isExternalUser">
      <div
        class="action-more"
        [closeUponSelection]="true"
        ngDropdown
        (click)="$event.stopPropagation()"
        [templateRef]="attachmentActions">
        <i class="material-symbols-outlined neumorph-btn">more_horiz</i>
      </div>
    </div>
  </div>
</div>

<ng-template #attachmentActions>
  <div class="dropdown-options-container">
    <div class="dropdown-option" *ngIf="attachmentType !== attachmentTypes.Link" (click)="downloadAttachment($event)">{{T.common.download | translate}}</div>
    <div class="dropdown-option" (click)="deleteAttachment($event)">{{T.common.delete | translate}}</div>
  </div>
</ng-template>
